import * as chains from "./chains";

// If you add coins for a new network, make sure Weth address (for the router you are using) is the first entry
const POLYGONCoins = [
  {
    name: "Matic",
    abbr: "Matic",
    address: "", // Weth address is fetched from the router
  },
  {
    name: "ECS Gold",
    abbr: "ECG",
    address: "0x3050731a7Ab18D05eAa5E01D66DF33E04444e72c",
  },
  {
    name: "USD Token",
    abbr: "USDT",
    address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
  },
];

const BNBCoins = [
  {
    name: "BNB",
    abbr: "BNB",
    address: "", // Weth address is fetched from the router
  },
  {
    name: "ECS Gold",
    abbr: "ECG",
    address: "0x55E73e5580df9035F8E490AF086d58c5CEec423e",
  },
  {
    name: "USD Token",
    abbr: "USDT",
    address: "0x55d398326f99059fF775485246999027B3197955",
  },
];

const COINS = new Map();
COINS.set(chains.ChainId.POLYGON, POLYGONCoins);
COINS.set(chains.ChainId.BNB, BNBCoins);

export default COINS;
